import { useEffect } from 'react';
import { applySeoForPath } from './apply-seo';

interface SubscribableRouter {
  readonly state: { readonly location: { readonly pathname: string } };
  subscribe(fn: (state: { location: { pathname: string } }) => void): () => void;
}

/**
 * Keeps <head> metadata in sync with the current route. Applied after the
 * navigation commits (macrotask), so it runs after the screen's own effects
 * and indexable pages always end with their SEO title.
 */
export const useRouteSeo = (router: SubscribableRouter) => {
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;
    const schedule = (pathname: string) => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => applySeoForPath(pathname), 0);
    };
    schedule(router.state.location.pathname);
    const unsubscribe = router.subscribe(state =>
      schedule(state.location.pathname)
    );
    return () => {
      if (timer) clearTimeout(timer);
      unsubscribe();
    };
  }, [router]);
};
